import React from 'react';
import clsx from 'clsx';
import styles from './Tabs.module.css';

export interface TabItem {
  key: string;
  label: string;
  disabled?: boolean;
}

interface TabsProps {
  items: TabItem[];
  activeTab: string;
  onTabChange: (tabKey: string) => void;
  className?: string;
}

const Tabs: React.FC<TabsProps> = ({ items, activeTab, onTabChange, className = '' }) => {
  return (
    <div className={clsx(styles.tabs, className)}>
      {items.map((item) => (
        <button
          key={item.key}
          className={clsx(styles.tabButton, activeTab === item.key && styles.tabButtonActive)}
          onClick={() => !item.disabled && onTabChange(item.key)}
          disabled={item.disabled}
          data-test-id={`tab-${item.key}`}
        >
          {item.label}
        </button>
      ))}
    </div>
  );
};

export default Tabs;
